export default __webpack_public_path__ + "static/media/8.524eaff2.jpg";